import { withAsync } from '@/components/Async'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/freight',
    name: 'freight',
    menuTitle: 'freight.result',
    component: withAsync(() => import(/* webpackChunkName: "Freight" */ '@/containers/Freight')),
    exact: true,
    permissionCode: 'ship:freight',
  },
]

export default routes
